import { FC,useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '~/hooks/useRedux';
import { ConfirmLeaveEditingQr } from '~/pages/CreateQR/components/ConfirmLeaveEditingQr';
import { stepperSlice } from '~/store/reducers/stepepr';
import { getStepperData } from '~/store/reducers/stepepr/selectors';
import useBuilderStore from '~/store/useBuilderStore';

interface ConfirmNavigateModalProps {
  activeStep?: number;
}

const stepperActions = stepperSlice.actions;

export const ConfirmNavigateModal: FC<ConfirmNavigateModalProps> = ({ activeStep }) => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const { redirectRoute } = useSelector(getStepperData);

  const { setActiveStep } = useBuilderStore();

  useEffect(() => {
    if (activeStep !== undefined) {
      setActiveStep(activeStep);
    }
  }, [activeStep]);

  const resetStepper = () => {
    dispatch(stepperActions.setRedirectRoute(''));
  };

  const onAcceptRedirect = () => {
    navigate(redirectRoute);
    resetStepper();
  };

  return <ConfirmLeaveEditingQr isOpen={!!redirectRoute} onAccept={onAcceptRedirect} onClose={resetStepper} />;
};
